import { Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import {
  jobBoardRouteName,
  JobBoardRouteOptions,
  jobBoardsList,
} from '../../candidates/utils/CandidateHelper';
import { JobBoardSearchChildRoutes } from '../routes/index';

const JobBoardSearch = () => {
  const [value, setValue] = React.useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const currentPath = location.pathname.split('/');

  useEffect(() => {
    if (
      currentPath.length >= 2 &&
      currentPath[2] === 'monster' &&
      params.get('loc') === 'europe,uk'
    ) {
      setValue(9);
    } else {
      const tabIndex = jobBoardRouteName.indexOf(currentPath[2] as JobBoardRouteOptions);
      setValue(tabIndex >= 0 ? tabIndex : 0);
    }
  }, [currentPath, params]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const selectedJobBoard = jobBoardsList[newValue];
    navigate(selectedJobBoard.url as string);
  };
  return (
    <Grid container display="flex">
      <Paper
        sx={{
          height: 125,
          width: '100%',
          borderRadius: 1.2,
          p: 0,
        }}
      >
        <Grid mt={4} ml={4}>
          <Typography fontSize={24} fontWeight={700}>
            Job Boards
          </Typography>
        </Grid>
        <Grid xs={12}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable tabs with image and text"
            sx={{ height: 60, ml: 2 }}
          >
            {jobBoardsList.map((jobBoard, index) => (
              <Tab
                key={index}
                icon={jobBoard.icon}
                label={jobBoard.name}
                iconPosition="start"
                sx={{
                  p: 1.5,
                  fontSize: 14,
                  fontWeight: 700,
                  textTransform: 'initial',
                }}
              />
            ))}
          </Tabs>
        </Grid>
      </Paper>
      <Grid item xs={12}>
        <JobBoardSearchChildRoutes />
      </Grid>
    </Grid>
  );
};
export default JobBoardSearch;
